import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { FC, useEffect, useState } from "react";
import { RESET_PASSWORD_ANONYMUS } from "../../utils/endpoints";
import { Toast } from "../../components/atom/Toast/Toast";
import api from "../../utils/api";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import ResetPasswordSuccessful from "./ResetPasswordSuccessful";
import InputFieldComponent from "../../components/molecule/InputField/InputFieldComponent";

const schema = z.object({
  email: z
    .string()
    .min(1, { message: "O e-mail é obrigatório" })
    .email("Email inválido"),
});

interface ResetPasswordProps {
  isOpen: boolean;
  onBack: () => void;
}

interface FormData {
  email: string;
}

const ResetPassword: FC<ResetPasswordProps> = ({ isOpen, onBack }) => {
  const { addToast } = Toast();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (isOpen) {
      reset({
        email: "",
      });
    }
  }, [isOpen, reset]);

  const handleResetPassword = handleSubmit(async (data) => {
    try {
      const response = await api.post(RESET_PASSWORD_ANONYMUS, {
        email: data.email,
      });
      if (response.data.statusCode === 200) {
        setIsSubmitted(true);
      } else {
        addToast({ title: response.data.message, status: "error" });
      }
    } catch (error) {
      console.error("API Error:", error);
      addToast({ title: "Erro ao resetar a senha", status: "error" });
    }
  });

  if (isSubmitted) {
    return <ResetPasswordSuccessful onBack={onBack} />;
  }

  return (
    <Box
      as="form"
      display="flex"
      width="100%"
      flexDirection="column"
      gap={8}
      onSubmit={handleResetPassword}
    >
      <Flex direction="column" gap={4}>
        <Button
          onClick={onBack}
          alignSelf="flex-start"
          variant="tertiary"
          leftIcon={<ChevronLeftIcon boxSize={4} viewBox="0 0 24 22" />}
        >
          <Text as="b">Voltar</Text>
        </Button>
        <Heading as="h1">Esqueci-me da senha</Heading>
        <InputFieldComponent
          label="Insira o seu email"
          name="email"
          type="email"
          register={register}
          errors={errors}
        />
      </Flex>
      <Button type="submit" alignSelf="flex-start">
        Enviar
      </Button>
    </Box>
  );
};

export default ResetPassword;
